module.exports = __webpack_public_path__ + "static/img/v1.661cfbcf.png";